// native
import { Component, EventEmitter, Input, Output } from '@angular/core';

// models
import { DeviceStepResult, NetworkStepResult, PatientStepResult } from '../../home-management.types';

@Component({
  selector: 'app-home-review-step',
  templateUrl: './review-step.component.html',
  standalone: false
})
export class ReviewStepComponent {
  @Input() patient: PatientStepResult;
  @Input() device: DeviceStepResult;
  @Input() network: NetworkStepResult;
  @Input() isSubmitting = false;

  @Output() submit: EventEmitter<void> = new EventEmitter<void>();
  @Output() back: EventEmitter<void> = new EventEmitter<void>();

  // For a new device the record is created on submit, so its name comes from the
  // captured create payload; for an existing device it comes from the selection.
  get deviceName(): string {
    if (!this.device)
      return '';
    return this.device.mode === 'new'
      ? (this.device.newDevice?.name ?? '')
      : (this.device.device?.name ?? '');
  }
}
